import { useState } from "react";
import HeroBanner from "../components/HeroBanner";
import ServicesSection from "../components/ServicesSection";
import ResourcesSection from "../components/ResourcesSection";
import TrendsSection from "../components/TrendsSection";
import WhyTibsTaps from "../components/WhyTibsTaps";
import TestimonialsSection from "../components/TestimonialsSection";
import ServiceAreaSection from "../components/ServiceAreaSection";
import BookingSection from "../components/BookingSection";
import BlogSection from "../components/BlogSection";
import GallerySection from "../components/GallerySection";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import ScrollButtons from "../components/ScrollButtons";

export default function LandingPage() {
  return (
    <div className="bg-[#0A0A0A]" data-testid="landing-page">
      <HeroBanner />
      <main>
        <ServicesSection />
        <WhyTibsTaps />
        <TestimonialsSection />
        <BookingSection />
        <BlogSection />
        <ResourcesSection />
        <TrendsSection />
        <ServiceAreaSection />
        <GallerySection />
        <ContactForm />
      </main>
      <Footer />
      <ScrollButtons />
    </div>
  );
}
